import { formatDate } from "../services/receipt.service";
import {
    buildDocDefinition, openPdf, buildCollectionBody, fmtLongDate, fmtINR,
} from "./reportTheme";

export const DailySevaCollectionPrint = async (selectedDate, logoBase64, sevaCollectionMap) => {
    const { body, grandTotal, count } = buildCollectionBody(sevaCollectionMap, "poojaAmt1", formatDate);

    return openPdf(
        buildDocDefinition({
            logoBase64,
            title: "Seva Collection",
            summary: [
                { label: "Date", value: fmtLongDate(selectedDate) },
                { label: "Total Receipts", value: count },
                { label: "Total Seva Amount", value: fmtINR(grandTotal), accent: true },
            ],
            body,
        })
    );
};

export default DailySevaCollectionPrint;